import { type FC, type ReactNode } from 'react';
import classnames from 'classnames';

import dibsCss from 'dibs-css';

import styles from './PdpRespAboutItemPanelItemModuleDetail.module.css';

type Props = {
    dataTn: string;
    title: ReactNode;
    children: ReactNode;
};

export const PdpRespAboutItemPanelItemModuleDetail: FC<Props> = ({ title, children, dataTn }) => {
    if (!title || !children) {
        return null;
    }

    return (
        <div
            className={classnames(
                dibsCss.breakInsideAvoid,
                dibsCss.flex,
                dibsCss.gapXsmall,
                dibsCss.itemsStart,
                dibsCss.wFull,
                dibsCss.minW0
            )}
        >
            <div
                className={classnames(
                    styles.titleColumn,
                    dibsCss.minW0,
                    dibsCss.textNoir,
                    dibsCss.sassyFontBodyMediumHeavy,
                    dibsCss.flex,
                    dibsCss.flexWrap,
                    dibsCss.itemsCenter,
                    dibsCss.gapXxsmall,
                    dibsCss.flexShrink0
                )}
                data-tn="pdp-spec-title"
            >
                {title}
            </div>
            <div
                className={classnames(
                    styles.valueColumn,
                    dibsCss.minW0,
                    dibsCss.sassyFontBody,
                    dibsCss.flex1,
                    dibsCss.minW0,
                    dibsCss.breakWords
                )}
                data-tn={`pdp-spec-${dataTn}`}
            >
                {children}
            </div>
        </div>
    );
};
